/* eslint-disable import/no-cycle */
/* eslint-disable no-param-reassign */
/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */
import { set } from 'lodash-es';

import {
  findAllProducts,
  findAllGrids,
  findAllInsurers,
  findAllLegalForms,
  findAllQualityOccupants,
  findAllPositions,
  findAllEquipments,
  findAllEmployeesBrackets,
  findAllRecommendationsFromCompanyId,
} from '@/services/api/pricing/rater';

import {
  findDeclarationBySubscriptionId,
} from '@/services/api/buy/subscription';

// initial state
const state = {
  grids: [],
  insurers: [],
  legalForms: [],
  positions: [],
  products: [],
  equipments: [],
  qualityOccupant: [],
  employeesBrackets: [],
  claimsType: [
    { code: 4, name: 'Bris de glace' },
    { code: 5, name: 'Bris de machine' },
    { code: 10, name: 'Dégâts des eaux' },
    { code: 15, name: 'Incendie' },
    { code: 24, name: 'Vol / Vandalisme' },
    { code: 3, name: 'Autres' },
  ],
  recommendation: [],
};

// getters
const getters = {
  grids: (state) => state.grids,
  insurers: (state) => state.insurers,
  equipments: (state) => state.equipments,
  legalForms: (state) => state.legalForms,
  positions: (state) => state.positions,
  products: (state) => state.products,
  qualityOccupant: (state) => state.qualityOccupant,
  employeesBrackets: (state) => state.employeesBrackets,
  claimsType: (state) => state.claimsType,
  recommendation: (state) => state.recommendation,
};

// actions
const actions = {
  async initialize({ commit }) {
    const { data: legalForms } = await findAllLegalForms();
    const { data: qualityOccupant } = await findAllQualityOccupants();
    const { data: positions } = await findAllPositions();
    const { data: products } = await findAllProducts();
    const { data: grids } = await findAllGrids();
    const { data: insurers } = await findAllInsurers();
    const { data: employeesBrackets } = await findAllEmployeesBrackets();
    const { data: equipments } = await findAllEquipments();

    // link each product to a grid, and link each product to grids
    grids.forEach((grid) => {
      if (products.length) {
        const product = products
          .find((prod) => prod.id === grid.product.id);
        if (product) {
          // appends one or some grids by productId to a product
          if (!product.grids) {
            Object.assign(product, { grids: [] });
          }
          if (grid.enabled) {
            product.grids.push(grid.id);
          }
          // appends to a grid a product
          set(grid, 'product', { ...product });
        }
      }
    });
    commit('SET_VALUES', {
      grids,
      insurers,
      legalForms,
      positions,
      equipments,
      products,
      qualityOccupant,
      employeesBrackets,
    });
    return Promise.resolve();
  },
  getDeclarations(unset, id) {
    return findDeclarationBySubscriptionId(id);
  },
  async getRecommendation({ rootGetters, commit }) {
    const companyId = rootGetters['company/companyId'];
    const { data: recommendation } = await findAllRecommendationsFromCompanyId(companyId);
    commit('SET_VALUE', { recommendation });
    return recommendation;
  },
  setValue({ commit }, object) {
    commit('SET_VALUE', object);
  },
  setValueWithPath({ commit }, object) {
    commit('SET_VALUE_WITH_PATH', object);
  },
  clear({ commit }) {
    commit('CLEAR');
  },
};

// mutations
const mutations = {
  SET_VALUE(state, object) {
    const [key] = Object.keys(object);
    Object.assign(state, { [key]: object[key] });
  },
  SET_VALUES(state, values) {
    const keys = Object.keys(values);
    for (let i = 0; i < keys.length; i += 1) {
      const key = keys[i];
      if (key in state) {
        Object.assign(state, { [key]: values[key] });
      }
    }
  },
  SET_VALUE_WITH_PATH(state, { value, path }) {
    set(state, path, value);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
